// const { log } = require("console");

(function ($) {

  if ($('.block--carousel').length > 0) {
    const swiper = new Swiper('.swiper', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        767: {
          slidesPerView: 'auto',
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 'auto',
          spaceBetween: 60,
        },
        1200: {
          slidesPerView: 'auto',
          spaceBetween: 100,
        },
        1441: {
          spaceBetween: 160,
        }
      }
    });
  }

  if ($('.block--carousel-text').length > 0) {
    const swiper2 = new Swiper('.swiper2', {
      spaceBetween: 20,
      slidesPerView: 'auto',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        767: {
          slidesPerView: 'auto',
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 'auto',
          spaceBetween: 60,
        },
        1200: {
          slidesPerView: 'auto',
          spaceBetween: 100,
        },
        1441: {
          slidesPerView: 'auto',
          spaceBetween: 160,
        }
      }
    });
  }

  let userInteracted = false; 

  if ($('.swiper-team').length > 0) {
    const teamSwiper1 = new Swiper('.swiper-team', {
        slidesPerView: 'auto',
        spaceBetween: 45,
        centeredSlides: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Detect user interaction with the Swiper
    teamSwiper1.on('touchStart', () => {
        userInteracted = true;
    });

    // ScrollTrigger for scrubbing effect
    ScrollTrigger.create({
        trigger: '.swiper-team',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        onUpdate: (self) => {
            if (!userInteracted) {
                const maxTranslate = 150;
                const translateValue = -self.progress * maxTranslate;
                teamSwiper1.setTranslate(translateValue);
            }
        },
    });
  }

  if ($('.swiper-team-2').length > 0) {
    const teamSwiper2 = new Swiper('.swiper-team-2', {
        slidesPerView: 'auto',
        spaceBetween: 45,
        centeredSlides: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Detect user interaction with the Swiper
    teamSwiper2.on('touchStart', () => {
        userInteracted = true;
    });

    ScrollTrigger.create({
        trigger: '.swiper-team-2',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        onUpdate: (self) => {
            if (!userInteracted) {
                const maxTranslate = 150;
                const translateValue = self.progress * maxTranslate;
                teamSwiper2.setTranslate(translateValue);
            }
        },
    });
  }

  if ($('.swiper-team-3').length > 0) {
    const teamSwiper3 = new Swiper('.swiper-team-3', {
        slidesPerView: 'auto',
        spaceBetween: 45,
        centeredSlides: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Detect user interaction with the Swiper
    teamSwiper3.on('touchStart', () => {
        userInteracted = true; // Mark as interacted on touch
    });

    // ScrollTrigger for scrubbing effect
    ScrollTrigger.create({
        trigger: '.swiper-team-3',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        onUpdate: (self) => {
            if (!userInteracted) {
                const maxTranslate = 150;
                const translateValue = -self.progress * maxTranslate;
                teamSwiper3.setTranslate(translateValue);
            }
        },
    });
  }

  let userInteractedContact = false; 

  if ($('.swiper-team-contact').length > 0) {
    const teamSwiperContact = new Swiper('.swiper-team-contact', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: false,
        grabCursor: true,
        breakpoints: {
          767: {
            spaceBetween: 45,
          },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // Detect user interaction with the Swiper
    teamSwiperContact.on('touchStart', () => {
        userInteractedContact = true;
    });

    // ScrollTrigger for scrubbing effect
    ScrollTrigger.create({
        trigger: '.swiper-team-contact',
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        onUpdate: (self) => {
            if (!userInteractedContact) {
                const maxTranslate = 150;
                const translateValue = -self.progress * maxTranslate;
                teamSwiperContact.setTranslate(translateValue);
            }
        },
    });
  }


})(jQuery);